import React, { useCallback } from 'react';
import { RadioButton } from '@vectord/components';
import { useDispatch, useSelector } from 'react-redux';

import {
  learnerUpdateActionSelector,
  pastClassesStatusSelector,
  PAST_CLASSES_VISIBILITY_DATA,
  selectedSuperBatchSelector,
  setPastClassesStatus,
} from 'features/classCreation';
import styles from './PastClassesVisibility.module.scss';

function PastClassesVisibility() {
  const dispatch = useDispatch();
  const learnerUpdateAction = useSelector(learnerUpdateActionSelector);
  const pastClassesStatus = useSelector(pastClassesStatusSelector);
  const selectedSuperBatch = useSelector(selectedSuperBatchSelector);
  const { batch_type: batchType } = selectedSuperBatch;

  const handleChange = useCallback(
    (event) => {
      dispatch(setPastClassesStatus(event.target.name));
    },
    [dispatch]
  );

  return (
    <div className={styles.root}>
      <div className={styles.title}>Past Classes</div>
      <div className="p-xs">
        {PAST_CLASSES_VISIBILITY_DATA[learnerUpdateAction][batchType]?.map(
          (data) => (
            <RadioButton
              key={data.label}
              text={data.label}
              name={data.value}
              onChange={handleChange}
              active={pastClassesStatus === data.value}
              textClassName={styles.label}
              className="m-b-xs"
            />
          )
        )}
      </div>
    </div>
  );
}
export default PastClassesVisibility;
